// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


function toDisplayStringPlural(x) {
  switch (x) {
    case "BUYER_NEED" :
        return "buyer needs";
    case "FOR_SALE_PROPERTY" :
        return "properties";
    case "RENTAL_NEED" :
        return "rental needs";
    case "RENTAL_PROPERTY" :
        return "rental properties";
    
  }
}

function toDisplayStringSingular(x) {
  switch (x) {
    case "BUYER_NEED" :
        return "buyer need";
    case "FOR_SALE_PROPERTY" :
        return "property";
    case "RENTAL_NEED" :
        return "rental need";
    case "RENTAL_PROPERTY" :
        return "rental property";
    
  }
}

function getAreaGroupId(areaGroup) {
  switch (areaGroup.TAG) {
    case "UserAreaGroup" :
    case "ChapterAreaGroup" :
        return areaGroup.id;
    case "NewAreaGroup" :
        return "new";
    
  }
}

function notificationTypesString(notificationTypes) {
  var match = notificationTypes.includes("FOR_SALE_PROPERTY");
  var match$1 = notificationTypes.includes("RENTAL_PROPERTY");
  var propertiesPart = match ? "properties" : (
      match$1 ? "rental properties" : undefined
    );
  var match$2 = notificationTypes.includes("BUYER_NEED");
  var match$3 = notificationTypes.includes("RENTAL_NEED");
  var clientNeedPart = match$2 ? (
      match$3 ? "client needs" : "buyer needs"
    ) : (
      match$3 ? "rental needs" : undefined
    );
  if (propertiesPart !== undefined) {
    if (clientNeedPart !== undefined) {
      return propertiesPart + (" & " + clientNeedPart);
    } else {
      return propertiesPart;
    }
  } else if (clientNeedPart !== undefined) {
    return clientNeedPart;
  } else {
    return "entities";
  }
}

exports.toDisplayStringPlural = toDisplayStringPlural;
exports.toDisplayStringSingular = toDisplayStringSingular;
exports.getAreaGroupId = getAreaGroupId;
exports.notificationTypesString = notificationTypesString;
/* No side effect */
